import { Component } from "react";
import { Global, css } from "@emotion/react";
import * as React from 'react';
export default {
  Component,
  Global,
  css,
  React
};